import { render, staticRenderFns } from "./ListDistributor.vue?vue&type=template&id=d7b24e30&"
import script from "./ListDistributor.vue?vue&type=script&setup=true&lang=js&"
export * from "./ListDistributor.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ListDistributor.vue?vue&type=style&index=0&id=d7b24e30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports